import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Field } from "@/manager/ui";

export default function ManagerLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [f, setF] = useState({ email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const res = await login(f.email, f.password);
    setBusy(false);
    if (res.ok) navigate("/manager"); else toast.error(res.error);
  };
  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#F7F5F0]" data-testid="manager-login-page">
      <div className="hidden lg:flex flex-col justify-between bg-[#101B28] p-14 text-[#F7F5F0]">
        <p className="font-display text-3xl">AURA <span className="text-[#BBA77D]">Manager</span></p>
        <div>
          <p className="text-[10px] uppercase tracking-[0.35em] text-[#BBA77D] mb-4">Operations Hub</p>
          <h1 className="font-display text-5xl leading-[1.05] max-w-md">Todo Aura, bajo control.</h1>
          <p className="mt-6 text-[#F7F5F0]/60 max-w-sm">Eventos, tareas, personal, limpieza, inventario y finanzas en un solo lugar. Uso interno: no modifica la web pública.</p>
        </div>
        <p className="text-xs text-[#F7F5F0]/40">Aura Sant Cugat · Aura Eventos Externos</p>
      </div>
      <div className="flex items-center justify-center p-6">
        <form onSubmit={submit} className="w-full max-w-sm space-y-5" data-testid="manager-login-form">
          <p className="lg:hidden font-display text-3xl text-[#101B28]">AURA <span className="text-[#BBA77D]">Manager</span></p>
          <h2 className="font-display text-3xl text-[#101B28]">Acceso privado</h2>
          <Field label="Email"><Input type="email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="manager-login-email" className="bg-white" required /></Field>
          <Field label="Contraseña"><Input type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} data-testid="manager-login-password" className="bg-white" required /></Field>
          <Button type="submit" disabled={busy} data-testid="manager-login-submit" className="w-full rounded-full bg-[#101B28] hover:bg-[#1d2c3f] text-[#F7F5F0] py-6">Entrar</Button>
        </form>
      </div>
    </div>
  );
}
